export const COPYRIGHT = `© ASTRAL Limited ${new Date().getFullYear()}`;
